// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2nGie","gfeWrapper":"CalendarEvent_gfeWrapper__13w-8"};